// Astra · fechas en el idioma de la página.
//
// Hoy hay listas de meses en español escritas a mano en varios componentes
// (`HeroAgenda`, `ChipFecha`, `AccountMenu`, `ArticleBody`) y en los servicios.
// Cada uno pasa a usar esto en la tanda que lo traduce.
//
// 🔴 **El mes corto lleva tabla propia en los cuatro idiomas**, y no `Intl`.
// Los chips de fecha están dibujados para tres letras, y `Intl` da «SEPT» en
// español, «FEBR» en catalán y «JANV» o «AOÛT» en francés. En español sale lo
// mismo que antes, carácter por carácter.
import { IDIOMA } from "./idioma";

const MESES_CORTOS = {
  es: ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"],
  en: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
  ca: ["GEN", "FEB", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OCT", "NOV", "DES"],
  fr: ["JAN", "FÉV", "MAR", "AVR", "MAI", "JUN", "JUL", "AOÛ", "SEP", "OCT", "NOV", "DÉC"],
};

function comoFecha(valor) {
  const d = valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** El mes en tres letras y mayúsculas. `mes` va de 0 a 11. */
export function mesCorto(mes, idioma = IDIOMA) {
  return (MESES_CORTOS[idioma] || MESES_CORTOS.es)[mes] || "";
}

/** «3 de noviembre de 2026», «3 November 2026», «3 de novembre del 2026», «3 novembre 2026». */
export function fechaLarga(valor, idioma = IDIOMA) {
  const d = comoFecha(valor);
  if (!d) return "";
  return new Intl.DateTimeFormat(idioma === "en" ? "en-GB" : idioma, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(d);
}

const MESES_LARGOS_ES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

/**
 * El mes y el año, para «desde marzo de 2026»: «marzo de 2026», «March 2026»,
 * «mars 2026». El español sale de la tabla de antes, carácter por carácter.
 *
 * ⚠️ **En catalán lleva delante su «de», ya apostrofado**: «de març del 2026»,
 * «d’agost del 2026». Así la frase se escribe «des {fecha}» y sale «des d’agost»,
 * que con «des de {fecha}» saldría mal. Se saca de la fecha larga quitándole el día.
 */
export function mesYAno(valor, idioma = IDIOMA) {
  const d = comoFecha(valor);
  if (!d) return "";
  if (idioma === "es" || !idioma) return `${MESES_LARGOS_ES[d.getMonth()]} de ${d.getFullYear()}`;
  if (idioma === "ca") return fechaLarga(d, "ca").replace(/^\d+\s+/, "");
  return new Intl.DateTimeFormat(idioma === "en" ? "en-GB" : idioma, {
    month: "long",
    year: "numeric",
  }).format(d);
}
